export const ROUTES = {
  AUTH: {
    ROOT: '/auth',
    LOGIN: '/auth/login',
    REGISTRATION: '/auth/registration',
    TELEGRAM_REGISTRATION: '/auth/registration/telegram',
    VERIFY_EMAIL: '/auth/verifyEmail/:token',
    RESTORE: '/auth/restore',
    RESTORE_PASSWORD: '/auth/restorePasswd/:token',
    SUSPENDED: '/auth/suspended',
    AUTHORIZER: '/authorizer',
  },
  PAYMENT_LINKS: {
    ROOT: '/payment-links',
    START: '/payment-links/start',
    LIST: '/payment-links/list',
    HISTORY: '/payment-links/history',
    SETTINGS: '/payment-links/settings',
    DETAIL: '/payment-links/:id',
  },
  MASS_PAYMENTS: {
    ROOT: '/mass-payments',
    START: '/mass-payments/start',
    LIST: '/mass-payments/list',
    HISTORY: '/mass-payments/history',
    RECIPIENTS: '/mass-payments/recipients',
    SETTINGS: '/mass-payments/settings',
    DETAIL: '/mass-payments/:id',
  },
  EARN_ON_SWAP: {
    ROOT: '/earn-on-swap',
    START: '/earn-on-swap/start',
    LIST: '/earn-on-swap/list',
    SETTINGS: '/earn-on-swap/settings',
    WIDGET_DETAILS: '/earn-on-swap/widget/:id',
  },
  WALLET: {
    ROOT: '/wallet',
    MAIN: '/wallet/main',
    HISTORY: '/wallet/history',
    MERCURYO_KYC_MOCK: '/wallet/mercuryo-kyc-mock',
    MERCURYO_KYC_RESULT: '/wallet/mercuryo-kyc-result',
    MERCURYO_SELL_RESULT: '/wallet/mercuryo-sell-result',
  },
  INVOICES: {
    ROOT: '/invoices',
    START: '/invoices/start',
    LIST: '/invoices/list',
    SETTINGS: '/invoices/settings',
    DETAIL: '/invoices/:id',
  },
  API_AND_INTEGRATION: {
    ROOT: '/api-and-integrations',
    START: '/api-and-integrations/start',
    LIST: '/api-and-integrations/list',
    SETTINGS: '/api-and-integrations/settings',
  },
  PROFILE: {
    ROOT: '/profile',
    ACCOUNT_CENTER: '/profile/account-center',
    SECURITY: '/profile/security',
    PREFERENCES: '/profile/preferences',
  },
  CONFIRM: {
    PHONE: '/profile/confirm/phone',
    GOOGLE: '/profile/confirm/google',
    PASSWORD_CHANGE: '/profile/confirm/password/change',
    PHONE_DELETE: '/profile/confirm/phone/delete',
  },
}

const PAYMENT_LINKS_ROUTES = {
  START: 'payment-links-start',
  LIST: 'payment-links-list',
  HISTORY: 'payment-links-history',
  SETTINGS: 'payment-links-settings',
  DETAIL: 'payment-links-detail',
}

const MASS_PAYMENTS_ROUTES = {
  START: 'mass-payments-start',
  LIST: 'mass-payments-list',
  HISTORY: 'mass-payments-history',
  RECIPIENTS: 'mass-payments-recipients',
  SETTINGS: 'mass-payments-settings',
  DETAIL: 'mass-payments-detail',
}

const EARN_ON_SWAP_ROUTE_KEY = {
  START: 'earn-on-swap-start',
  LIST: 'earn-on-swap-links',
  SETTINGS: 'earn-on-swap-settings',
  WIDGET: 'earn-on-swap-widget-details',
}

const API_AND_INTEGRATION_ROUTE_KEY = {
  START: 'api-and-integration-start',
  LIST: 'api-and-integration-list',
  SETTINGS: 'api-and-integration-settings',
}

const INVOICES_ROUTES = {
  START: 'invoices-start',
  LIST: 'invoices-list',
  SETTINGS: 'invoices-settings',
  DETAIL: 'invoices-detail',
}

const PROFILE_ROUTES = {
  ACCOUNT_CENTER: 'profile-account-center',
  SECURITY: 'profile-security',
  PREFERENCES: 'profile-preferences',
}

export {
  PAYMENT_LINKS_ROUTES,
  MASS_PAYMENTS_ROUTES,
  EARN_ON_SWAP_ROUTE_KEY,
  API_AND_INTEGRATION_ROUTE_KEY,
  INVOICES_ROUTES,
  PROFILE_ROUTES,
}
